import { createTheme } from "@mui/material/styles";
import { createBreakpoints } from "@mui/system";

const DESIGN_COLORS = {
  ACCENT: {
    GREEN: "#D4FE75",
    LIGHT_GREEN: "#F2FFD7",
    RED: "#D80027",
    PINK: "#F8465E",
    YELLOW: "#FFC107",
  },
  SECONDARY: {
    TITLE: "#2F2F37",
    MAIN: "#54535D",
    POPULAR_QUERIES: "#82818E",
    MINOR: "#A9A9A9",
    LINES: "#C5C5C5",
    SCROLL: "#EAEBED",
    STROKE: "#EDEFF2",
    ACTIVE: "#ECECEE",
  },
  BACKGROUND: "#F7F7F8",
  WHITE: "#FFFFFF",
  BLACK: "#0C0C0E",
};
const FONTS = {
  MAIN: "SF PRO, Helvetica, Arial, sans-serif",
};

const values = {
  xs: 0,
  sm: 600,
  // md: 900,
  md: 1000, // added ru + 20
  lg: 1200,
  xl: 1536,
};

const breakpoints = createBreakpoints({ values });

export const appTheme = createTheme({
  breakpoints,
  typography: {
    fontFamily: FONTS.MAIN,
    fontStyle: "normal",
  },
  palette: {
    background: DESIGN_COLORS.BACKGROUND,
    black: DESIGN_COLORS.BLACK,
    white: DESIGN_COLORS.WHITE,
    accent: {
      green: DESIGN_COLORS.ACCENT.GREEN,
      lightGreen: DESIGN_COLORS.ACCENT.LIGHT_GREEN,
      red: DESIGN_COLORS.ACCENT.RED,
      pink: DESIGN_COLORS.ACCENT.PINK,
      yellow: DESIGN_COLORS.ACCENT.YELLOW,
    },
    secondary: {
      main: DESIGN_COLORS.BLACK,
      title: DESIGN_COLORS.SECONDARY.TITLE,
      gray: DESIGN_COLORS.SECONDARY.MAIN,
      popularQueries: DESIGN_COLORS.SECONDARY.POPULAR_QUERIES,
      minor: DESIGN_COLORS.SECONDARY.MINOR,
      lines: DESIGN_COLORS.SECONDARY.LINES,
      scroll: DESIGN_COLORS.SECONDARY.SCROLL,
      stroke: DESIGN_COLORS.SECONDARY.STROKE,
      active: DESIGN_COLORS.SECONDARY.ACTIVE,
    },
    primary: {
      main: DESIGN_COLORS.ACCENT.GREEN,
    },
    error: {
      main: DESIGN_COLORS.ACCENT.RED,
      light: DESIGN_COLORS.ACCENT.PINK,
    },
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          transition: theme.transitions.create(["all"]),
          "&.MuiButton-root:hover": {
            boxShadow: "none",
          },
        }),
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          borderRadius: "7px",
          padding: "4px 8px",
          fontSize: "18px",
          fontWeight: 500,
          height: "29px",
          ...(ownerState.color === "default" && {
            backgroundColor: theme.palette.background,
          }),
        }),
        label: {
          padding: 0,
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme }) => ({
          color: theme.palette.black,
          boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.16)",
          backgroundColor: theme.palette.white,
          padding: "10px 12px 14px",
          fontSize: "14px",
          lineHeight: "150%",
          borderRadius: "8px",
        }),
        arrow: ({ theme }) => ({
          color: theme.palette.white,
        }),
      },
    },
  },
});
